import AppConfigData from './app-config.json';
import { objectToObjectArray, cleanObject, isValidRequestData } from './../utils/utility';
import { LANG, COUNTRY_CODE, REGION_CODE } from './constants';
import { formatISO, format } from 'date-fns';
import { reverseTransformCountryVendorDataRevitalize } from './data-transform';

/*
export const prepareNewOrderRequestData = config => {
    const { newOrder, userProfile, captchaResponse, isQuote, base64FilesData, orderFiles } = config;
    let requestObj = {};

    let address = {};
    const ignoreFields = ["addressId", "email", "firstName", "lastName", "company", "envId", "companyTaxId", "consent", "subscription", "formValid", "comment", "emanifestCode"];
    for (let addressField in newOrder.addressData) {
        if (ignoreFields.indexOf(addressField) === -1 && newOrder.addressData[addressField]) {
            address[addressField] = newOrder.addressData[addressField];
        }
    }

    let orderDescription = "";
    let quantityForSerialAudit = 0;
    let productList = [];
    newOrder.selectedCategories.forEach((category, index) => {
        const includedForSerialAudit = newOrder.pickUpQuestionnaireData.serialAuditCategories.includes(category.categoryId);
        if (includedForSerialAudit) quantityForSerialAudit += parseInt(category.quantity);

        productList.push({
            categoryId: category.categoryId,
            quantity: category.quantity,
            categoryName: category.categoryType === "others" ? newOrder.otherCategoryName : category.categoryName,
            categoryType: category.categoryType,
            weight: category.categoryType === "others" ? newOrder.otherCategoryWeight : (category.weight * parseInt(category.quantity)).toFixed(2),
            originalCategoryName: category.originalCategoryName,
            serialAudit: includedForSerialAudit ? "Y" : "N"
        });
        
        if (category.quantity) {
            orderDescription += category.quantity + " ";
        }

        orderDescription += category.categoryName;
        
        if (index < newOrder.selectedCategories.length - 1) {
            orderDescription += ", ";
        }
    });

    let shippingMaterial = [];
    newOrder.selectedMaterials.forEach(parentMaterial => {
        parentMaterial.materials.forEach(material => {
            const shippingMaterialData = {
                materialCode: material.id,
                quantity: material.quantity,
                materialName: material.name,
                materialFamily: parentMaterial.id,
                materialLongDesc: material.label,
                materialFamilyDesc: material.title,
                serviceType: material.serviceType,
                materialSubFamily: material.family,
                ...(material.weight) && {
                    weight: material.weight
                }
            }

            if (parseInt(material.quantity)) {
                shippingMaterial.push(shippingMaterialData);
                orderDescription += material.quantity + " " + material.name + ", ";
            }
        });
    });

    orderDescription = orderDescription.trim().slice(0, -1); // remove comma from the end

    requestObj.address = address;
    requestObj.description = "new order";
    requestObj.email = newOrder.addressData.email;
    requestObj.contactNo = newOrder.addressData.contactNo;
    requestObj.firstName = newOrder.addressData.firstName;
    requestObj.lastName = newOrder.addressData.lastName;
    requestObj.company = newOrder.addressData.company;    
    requestObj.categoryList = productList;
    requestObj.shippingMaterial = shippingMaterial;
    requestObj.orderType = newOrder.orderType;
    requestObj.orderTypeId = newOrder.orderType;
    requestObj.surveyEnabled = newOrder.addressData.surveyConsent;
    requestObj.equipmentOwnedByHP = newOrder.getStartedOrderQuestionnaireData.equipmentOwnedByHP;
    requestObj.userId = userProfile.userId;
    requestObj.captchaResponse = captchaResponse;
    requestObj.reportingCost = newOrder.quoteSummary.reportingCost;
    requestObj.logisticsCost = newOrder.quoteSummary.logisticsCost;
    requestObj.totalCost = newOrder.quoteSummary.totalCost;
    requestObj.currencyCode = newOrder.quoteSummary.currencyCode;
    requestObj.userType = userProfile.userType;
    requestObj.partnerType = userProfile.partnerType;
    requestObj.quantityForSerialAudit = quantityForSerialAudit;
    
    requestObj.createdByEmail = userProfile.emailAddress;
    requestObj.createdByFirstName = userProfile.firstName;
    requestObj.createdByLastName = userProfile.lastName;
    
    requestObj.priceList = userProfile.priceList;

    const pickUpQuestionnaireData = {
        shippingProvided: newOrder.pickUpQuestionnaireData.shippingProvided || "N",
        consolidateMaterial: newOrder.pickUpQuestionnaireData.consolidateMaterial || "N",
        packagingProvided: newOrder.pickUpQuestionnaireData.packagingProvided || "N",
        ...(newOrder.pickUpQuestionnaireData.fiscalOrder) && {
            fiscalOrder: newOrder.pickUpQuestionnaireData.fiscalOrder
        }
    }

    if (newOrder.pickUpQuestionnaireData.reportingOptions.length) {
        const reportingOptions = {};
        newOrder.pickUpQuestionnaireData.reportingOptions.forEach(option => {
            reportingOptions[option] = "Y";
        });
        pickUpQuestionnaireData.reportingOptions = reportingOptions;
    }

    requestObj.pickUpQuestionnaireData = pickUpQuestionnaireData;
    
    if (userProfile.amplifyProgram) {
        requestObj.amplifyProgram = userProfile.amplifyProgram;
    }

    if (newOrder.addressData.companyTaxId || userProfile.companyTaxId) {
        requestObj.companyTaxId = newOrder.addressData.companyTaxId || userProfile.companyTaxId;
    }
    
    if (newOrder.addressData.personalTaxId || userProfile.personalTaxId) {
        requestObj.personalTaxId = newOrder.addressData.personalTaxId || userProfile.personalTaxId;
    }
    
    if (newOrder.addressData.comment) {
        requestObj.specialInstructions = newOrder.addressData.comment;
    }
    
    if (newOrder.addressData.cellPhoneNumber) {
        requestObj.cellPhoneNumber = newOrder.addressData.cellPhoneNumber;
    }
    
    if (newOrder.totalCategoriesWeight) {
        requestObj.weight = newOrder.totalCategoriesWeight;
    }

    if (newOrder.quoteToOrder && newOrder.orderConfirmationId) {
        requestObj.orderId = newOrder.orderConfirmationId;
    }
    
    if (orderFiles) {
        requestObj.orderFiles = orderFiles;
    }

    /*let orderFiles = base64FilesData ? base64FilesData.map(file => {
        let fileType = file.id;
        if (file.id === "orderDataFile") fileType = "product";
        if (file.id === "invoiceFile") fileType = "invoice";

        let result = {};

        if (typeof file.base64String === "string") {
            result.fileFormat = file.name.substr(file.name.lastIndexOf(".") + 1 );
            result.fileDescription = file.name;
            result.fileContent = file.base64String.split(',')[1];
            result.fileType = fileType;
        }
        else {
            if (file.base64String.externallyHostedData) {
                result.fileFormat = file.base64String.externallyHostedData.fileFormat;
                result.fileDescription = file.base64String.externallyHostedData.fileDescription;
                result.fileContent = file.base64String.externallyHostedData.fileContent;
                result.fileType = fileType;
            }
        }

        return result;
    }) : [];

    if (orderFiles.length) {
        requestObj.orderFiles = orderFiles;
    }

    return requestObj;
}
*/

export const prepareGetCategoriesRequestData = customerType => {
    return {
        customerType: customerType
    }
}

export const prepareShippingMaterialsRequestData = (orderType, categories, serviceType) => {
    let categoriesList = [];

    categories.forEach(category => {
        categoriesList.push({
            categoryId: category.categoryId,
            quantity: category.quantity ? category.quantity : "0",
            ...(category.weight) && {
                weight: category.weight.toString()
            }
        });
    });

    const requestObj = {
        orderType: orderType,
        shippingMaterialList: categoriesList,
        ...(serviceType) && {
            serviceType: serviceType
        }
    };

    return requestObj;
}

export const prepareAddUserRequestdata = (authorization, registerForm, checkoutOption) => {
    let result = {};
    result.userId = authorization.userId;
    result.firstName = authorization.givenName;
    result.lastName = authorization.familyName;
    result.emailAddress = authorization.email;

    if (authorization.userPreRegistrationResponse) {
        result.isBulkUploaded = true;
    }

    result.language = LANG;
    result.country = COUNTRY_CODE;
    result.region = REGION_CODE;

    for (let field in registerForm) {
        const currentField = registerForm[field];
        const isFieldCosmetic = currentField.hasOwnProperty("cosmetic") && currentField.cosmetic === true;
        if ((!currentField.hidden && !isFieldCosmetic) || field === "userType" || field === "contactNo") {
            result[field] = currentField.value;
        }
    }
    if (result.amplifyCompany) {
        if (result.userType === "hp_partner") {
            let [partnerId, locationId, amplifyCompany] = result.amplifyCompany.split('|||---|||');
            let amplifySearchText = result.partnerId;
            result = { ...result, partnerId, locationId, amplifyCompany, amplifySearchText };
        } else {
            result.partnerId = null;
            result.amplifyCompany = null;
        }
    }
    if (checkoutOption) {
        result.checkoutOption = checkoutOption;
    }
    result.hpPickUp = result.hpPickUp === "Y";
    result.amplifyProgram = result.amplifyProgram === "Y";
    return result;
}


export const prepareGetUserProfilesListRequestData = (config, isForServicePrices) => {
    let result = {};

    // if (config.searchText) {
    //     result.searchText = config.searchText;
    // }

    result.searchText = config.searchText ? config.searchText : null;

    if (config.userType) {
        result.userType = config.userType;
    }
    result.offset = config.offset;
    result.limit = config.limit || 6;

    if (config.sortBy) {
        result.sortBy = config.sortBy;
        result.orderBy = config.orderAsc ? "ASC" : "DESC";
        // orderBy and sortBy should always go together or not at all
    }

    if (config.filterBy && config.filterByValue) {
        result.filterBy = config.filterBy;
        result.filterByValue = isForServicePrices ? config.filterByValue : [config.filterByValue]
    }

    if (config.lspId) {
        result.lspId = config.lspId;
    }

    return result;
}

export const prepareGetUserProfilesListRequestDataPO = (config, isForServicePrices) => {
    let result = {};

    // if (config.searchText) {
    //     result.searchText = config.searchText;
    // }

    result.searchText = config.searchText ? config.searchText : null;

    if (config.userType) {
        result.userType = config.userType;
    }
    result.offset = config.offset;
    result.limit = config.limit || 6;

    if (config.sortBy) {
        result.sortBy = config.sortBy;
        result.orderBy = config.orderAsc ? "ASC" : "DESC";
        // orderBy and sortBy should always go together or not at all
    }

    if (config.filterBy && config.filterByValue) {
        result.filterBy = config.filterBy;
        result.filterByValue = isForServicePrices ? config.filterByValue : [config.filterByValue]
    }

    if (config.lspId) {
        result.lspId = config.lspId;
    }

    return result;
}

export const prepareUpdateUserRequestdata = data => {
    const ignoreFields = ["email", "userName", "password", "region", "country", "userType"];
    let result = {};

    for (let field in data) {
        if (ignoreFields.indexOf(field) === -1) {
            result[field] = data[field].value;
        }
    }

    return [result];
}

export const prepareGetTokenRequestDataForGuest = () => {
    return {};
}

export const prepareSurveysRequestData = (data, email, questionaire) => {
    let requestData = {};
    requestData.surveyName = data.surveyName && data.surveyName.value;
    requestData.surveyType = data.surveyType && data.surveyType.value;
    requestData.fromDate = data.dateRange && data.dateRange.value[0];
    requestData.toDate = data.dateRange && data.dateRange.value[1];
    requestData.region = data.region && data.region.value.toUpperCase();
    requestData.country = data.country && data.country.value.toUpperCase();
    requestData.accountType = data.accountType && data.accountType.value;
    requestData.orderType = data.orderType && data.orderType.value;
    requestData.userType = data.userType && data.userType.value;
    requestData.partnerType = data.partnerType && data.partnerType.value;
    requestData.surveyScheduledDate = ((data.surveyType.value === "orderlevel" || Boolean(data.surveyScheduledDate.value) === false)) ? null : formatISO(data.surveyScheduledDate.value, { representation: 'date' });
    requestData.languageCode = LANG;
    requestData.surveyLink = "";
    requestData.createdBy = email;
    requestData.questionaire = questionaire ? [...questionaire].map(questionData => {
        let questionType = "";
        if (questionData.answerTypes.length === 2) questionType = "both";
        if (questionData.answerTypes.length === 1 && questionData.answerTypes[0] === "rating") questionType = "rating";
        if (questionData.answerTypes.length === 1 && questionData.answerTypes[0] === "comment") questionType = "comment";
        return {
            question: questionData.question,
            questionType
        };
    }) : [];
    return cleanObject(requestData, [null, "NO_VALUE"]);
}

export const prepareCustomizedReportsRequestData = (data) => {
    let requestData = {};
    requestData.year = data.year ? data.year : null;
    requestData.startDate = data.startDate ? data.startDate : null;
    requestData.endDate = data.endDate ? data.endDate : null;
    requestData.region = data.region ? data.region : null;
    requestData.country = data.country ? data.country : null;
    requestData.orderType = data.orderType ? data.orderType : null;
    requestData.company = data.company ? data.company : null;
    requestData.legalEntity = data.legalEntity ? data.legalEntity : null;
    requestData.limit = requestData.limit ? requestData.limit : "10";
    requestData.offset = requestData.offset ? requestData.offset : "0";

    if (!requestData.year && !requestData.startDate && !requestData.endDate) {
        requestData.year = "2022";
    }

    return cleanObject(requestData, [null, "NO_VALUE", "region", "country"]);
}

export const prepareExportPartnerFinancialsRequestData = (data) => {
    let requestData = {};
    requestData.year = data.year ? data.year : null;
    requestData.startDate = data.startDate ? data.startDate : null;
    requestData.endDate = data.endDate ? data.endDate : null;
    requestData.region = data.region ? data.region : null;
    requestData.country = data.country ? data.country : null;
    requestData.lineType = data.lineType ? data.lineType : null;
    requestData.company = data.company ? data.company : null;
    requestData.vendorName = data.vendorName ? data.vendorName : null;
    requestData.limit = requestData.limit ? requestData.limit : "10";
    requestData.offset = requestData.offset ? requestData.offset : "0";

    if (!requestData.year && !requestData.startDate && !requestData.endDate) {
        requestData.year = new Date().getFullYear().toString();
    }

    return cleanObject(requestData, [null, "NO_VALUE", "region", "country"]);
}


export const prepareUserProfileAddressData = (fields) => {
    let requestData = {};
    Object.keys(fields).forEach(field => {
        if (field !== "addressType" || (field === "addressType" && fields[field].touched) || REGION_CODE === "APJ") {
            requestData[field] = fields[field].value.trim() !== "" ? fields[field].value.trim() : null;
        }
    });
    delete requestData.name;
    return requestData;
}

export const prepareSurveyFeedbackRequestData = (quesData, surveyInfo) => {
    let requestData = {};
    requestData.surveyId = surveyInfo.surveyId;
    requestData.surveyRating = quesData;
    requestData.createdBy = surveyInfo.emailId;
    return requestData;
}
export const prepareAccountManagementUserFormData = (data, profile) => {
    let requestData = {};
    const ignoreFields = [];
    for (let key in data.userData.fields) {
        if (
            ignoreFields.indexOf(key) === -1 &&
            data.userData.fields[key].value &&
            (!data.userData.fields[key].hidden || key === "userType")
        ) {
            if (key === 'email') {
                requestData['emailAddress'] = data.userData.fields['email'].value;
            }
            else {
                requestData[key] = data.userData.fields[key].value;
            }
        }
    }

    requestData.country = profile.country;
    requestData.region = profile.region;
    if (requestData.amplifyCompany) {
        if (requestData.userType === "hp_partner") {
            let [partnerId, locationId, amplifyCompany] = requestData.amplifyCompany.split('|||---|||');
            let amplifySearchText = requestData.partnerId;
            requestData = { ...requestData, partnerId, locationId, amplifyCompany, amplifySearchText };
        } else {
            requestData.partnerId = null;
            requestData.amplifyCompany = null;
        }
    }
    requestData.hpPickUp = requestData.hpPickUp === "Y";
    requestData.amplifyProgram = requestData.amplifyProgram === "Y";
    requestData.userId = profile.userId ? profile.userId : '';
    requestData.visibleCountries = requestData.visibleCountries ? requestData.visibleCountries.split(',') : [];
    requestData.visibleRegions = requestData.visibleRegions ? requestData.visibleRegions.split(',') : [];
    return cleanObject(requestData, [null]);
}
export const prepareHelpFormData = (data, captchaResponse, aboutOrder, cancelOrder) => {
    let fields = data.helpData.fields;
    let requestObj = {};
    Object.keys(fields).forEach(fieldId => { requestObj[fieldId] = fields[fieldId].value; })
    requestObj.language = LANG;
    requestObj.orderNumber = [aboutOrder, cancelOrder].includes(requestObj.subject) ? requestObj.orderNumber : null;
    requestObj.captchaResponse = captchaResponse;
    return requestObj;
}
export const prepareDownloadReportRequestData = (fields, [from, to], userId, userType) => {
    let requestObj = {};
    Object.keys(fields).forEach(fieldId => {
        requestObj[fieldId] = fields[fieldId].value;
    });
    requestObj.fromDate = from.toISOString();
    requestObj.toDate = to.toISOString();
    requestObj.userId = ["Manager", "Vendor"].includes(userType) ? null : userId;
    requestObj.countryCode = requestObj.country;
    requestObj.country = null;
    if (requestObj.countryCode.indexOf("_") !== -1) {
        requestObj.languageCode = requestObj.countryCode.split("_")[0];
        requestObj.countryCode = requestObj.countryCode.split("_")[1];
    }
    return cleanObject(requestObj, ["NO_VALUE", "", null]);
}
export const prepareCustomizedReportRequestData = (fields) => {
    let requestObj = {};
    Object.keys(fields).forEach(fieldId => {
        requestObj[fieldId] = fields[fieldId].value;
    });
    return cleanObject(requestObj, ["NO_VALUE", "", null]);
}
export const prepareSaveReportRequestData = (fields) => {
    let requestObj = {};
    Object.keys(fields).forEach(fieldId => {
        if (fieldId === "dateRange") {
            requestObj.fromDate = fields.dateRange.value[0] instanceof Date ? fields.dateRange.value[0].toISOString() : fields.dateRange.value[0];
            requestObj.toDate = fields.dateRange.value[1] instanceof Date ? fields.dateRange.value[1].toISOString() : fields.dateRange.value[1];
        }
        else {
            requestObj[fieldId] = fields[fieldId].value;
        }
    });
    requestObj.countryCode = requestObj.country;
    requestObj.country = null;
    if (requestObj.countryCode.indexOf("_") !== -1) {
        requestObj.languageCode = requestObj.countryCode.split("_")[0];
        requestObj.countryCode = requestObj.countryCode.split("_")[1];
    }
    return cleanObject(requestObj, ["NO_VALUE", "", null]);
}

export const prepareSaveQuoteRequestData = (orderType, userProfile, quoteSummary, quote = {}) => {
    if (!orderType || !quoteSummary || !userProfile) return null;

    let requestObj = {};
    requestObj.orderType = orderType;
    console.log('Inside prepareSaveQuoteRequestData');
    const requiredUserProfileFields = ["userId", "firstName", "lastName", "email", "contactNo", "userType", "company", "customerType"];
    requiredUserProfileFields.forEach(field => {
        if (field === "email") {
            requestObj[field] = userProfile['emailAddress'];
        }
        else if (field === "customerType") {
            requestObj[field] = userProfile[field] || "indirect";
        }
        else {
            if (userProfile[field]) {
                requestObj[field] = userProfile[field];
            }
        }
    });

    if (quote.quoteDetails && quote.quoteDetails.quoteId) {
        requestObj.quoteId = quote.quoteDetails.quoteId;
    }

    requestObj.quotationId = quoteSummary.quotationId;
    requestObj.assetList = quoteSummary.assetList;
    requestObj.totalNetValue = (quoteSummary.totalNetValue).toFixed(2);

    if (userProfile.salesContractId) {
        requestObj.salesContractId = userProfile.salesContractId;
    }

    return requestObj;
}

export const prepareCreateQuoteRequestData = orderData => {
    let requestObj = {};
    requestObj.weight = orderData.totalCategoriesWeight;
    requestObj.shippingProvided = orderData.pickUpQuestionnaireData.shippingProvided || "N";

    if (orderData.pickUpQuestionnaireData.reportingOptions.includes("serialNoAudit") && orderData.pickUpQuestionnaireData.serialAuditCategories.length) {
        let quantity = 0;
        orderData.selectedCategories.forEach(category => {
            if (orderData.pickUpQuestionnaireData.serialAuditCategories.includes(category.categoryId)) {
                quantity += parseInt(category.quantity);
            }
        })

        requestObj.quantity = quantity;
    }

    return requestObj;
}

export const prepareCreateNewTeamRequestData = teamData => {
    let requestObj = {};
    requestObj.teamName = teamData.teamName;

    return requestObj;
}

export const prepareCreateInviteMemberRequestData = data => {
    let requestObj = {};
    requestObj.emailAddress = data.emailAddress;
    requestObj.inviteMessage = data.inviteMessage;
    return requestObj;
}

export const prepareAcceptInviteRequestData = data => {
    let requestObj = {};
    if (!data.teamId || !data.emailAddress) return null;

    requestObj.teamId = data.teamId;
    requestObj.emailAddress = data.emailAddress;

    return requestObj;
}

export const prepareDownloadCertificateRequestData = data => {
    let requestObj = {};

    if (!data.orderId || !data.certType) return null;

    requestObj.orderId = data.orderId;
    requestObj.certType = data.certType;
    requestObj.name = data.name || (data.orderId + "." + data.format);
    requestObj.format = data.format;

    return requestObj;
}

export const prepareGetCompaniesData = data => {
    let requestObj = { ...data };
    requestObj.countryCode = data.country.indexOf("_") > -1 ? data.country.split("_")[1] : data.country;
    return cleanObject(requestObj, ["NO_VALUE", "", null]);
}

export const prepareUpdateAddressRequestData = (data, addressOption) => {
    let requestData = {};
    Object.keys(data).forEach(field => {
        requestData[field] = data[field].value && data[field].value.trim() !== "" ? data[field].value.trim() : null;

    });
    if (addressOption) requestData.addressOption = addressOption;
    return requestData;
}
export const prepareUpdateContactRequestData = (data) => {
    let requestData = {};
    Object.keys(data).forEach(field => {
        requestData[field] = data[field].value && data[field].value.trim() !== "" ? field === "email" ? data[field].value.trim().toLowerCase() : data[field].value.trim() : null;

    });
    return requestData;
}

export const prepareApprovePriceListRequestData = (authorizationData, status) => {
    if (!authorizationData.userId || !authorizationData.email || !authorizationData.priceListUploadId || !status) return null;

    let requestData = {};
    requestData.priceListUploadId = authorizationData.priceListUploadId;
    requestData.approvedBy = authorizationData.email;
    requestData.status = status;

    return requestData;
}

export const prepareOrderFilesRequestData = files => {
    if (files && !files.length) return null;

    const validFiles = files.filter(file => file.data);
    if (!validFiles.length) return null;

    const formData = new FormData();
    validFiles.forEach(file => {
        if (file.id === "orderDataFile") {
            formData.append("productFile", file.data)
        }
        else {
            formData.append(file.id, file.data)
        }
    });

    return formData;
}

export const prepareSubscriptionConsentRequestData = userData => {
    const { firstName, lastName, email } = userData;
    const requestData = {
        action: "opt-in",
        purposeId: "SUBSCRIBE_TO_HP_NEWS_AND_OFFERS",
        verbiage: {
            "locale": LANG,
            "version": "1"
        },
        dataSubject: {
            name: {
                givenName: firstName,
                familyName: lastName
            },
            email: email
        }
    }

    return requestData;
}

export const prepareNewOrderRequestData = config => {
    const { newOrder, userProfile, quote, captchaResponse } = config;
    let requestData = {};

    requestData.userId = userProfile.userId;
    requestData.userType = userProfile.userType;
    requestData.customerType = userProfile.customerType || "indirect";

    requestData.orderType = newOrder.orderType;
    requestData.firstName = newOrder.addressData.firstName;
    requestData.lastName = newOrder.addressData.lastName;
    requestData.email = newOrder.addressData.email;
    requestData.contactNo = newOrder.addressData.contactNo;
    requestData.company = newOrder.addressData.company;

    requestData.quotationId = quote.quoteSummary.quotationId;
    requestData.assetList = quote.quoteSummary.assetList;
    requestData.totalNetValue = quote.quoteSummary.totalNetValue;

    let billingAddress = {};
    const billingAddressFields = ["addressLine1", "addressLine2", "city", "country", "state", "zipCode"];
    billingAddressFields.forEach(field => billingAddress[field] = newOrder.addressData[field]);

    let shippingAddress = {};
    const shippingAddressFields = ["addressLine1", "addressLine2", "city", "country", "state", "zipCode"];
    shippingAddressFields.forEach(field => shippingAddress[field] = newOrder.collectionInfoData[field]);

    if (newOrder.orderType == '1') {
        console.log('Inside shippingAddress condition');
        requestData.shippingAddress = shippingAddress;
    }

    if (quote.quoteDetails && quote.quoteDetails.quoteId) {
        requestData.quoteId = quote.quoteDetails.quoteId;
    }

    requestData.billingAddress = billingAddress;

    requestData.captchaResponse = captchaResponse || "captchaResponse";

    if (userProfile.salesContractId) {
        requestData.salesContractId = userProfile.salesContractId;
    }

    console.log("Order request data : " + JSON.stringify(requestData));

    return requestData;
}

export const prepareDirectCustomerQuoteRequestData = (directCustomerQuote, userProfile) => {
    let requestData = {};

    const { company, emailAddress, language, userId, firstName, lastName } = userProfile;
    const { selectedServicePriceList, rateCardSelection, subRateCardSelection, selectedPriceList, rateConversionSelection, quoteGeneralData, countryList, paymentOnePointOMarginData, paymentOnePointOneMarginData, vendorSelectionData, vendorSelection, internalHPComments } = directCustomerQuote;
    const {
        quoteNumber,
        customerName,
        orgId,
        contactEmailAddress,
        dateOfRequest,
        quoteCreationDate,
        requestorType,
        requestType,
        leadOrigin,
        leadSource,
        numberOfAssets,
        geographicalScope,
        region,
        ctResponsible,
        salesContactEmailAddress,
        currency,
        quoteValidUntil = new Date(),
        leadCountry
    } = quoteGeneralData;

    requestData.firstName = firstName;
    requestData.lastName = lastName;
    requestData.company = company;
    requestData.email = emailAddress;
    requestData.languageCode = language;
    requestData.userId = userId;

    requestData.quoteId = quoteNumber;
    requestData.quoteCreationDate = quoteCreationDate ? formatISO(new Date(quoteCreationDate)) : "";
    requestData.currencyCode = currency;
    requestData.customerType = "direct";
    requestData.company = customerName;//as customer is company
    requestData.salesPersonEmail = salesContactEmailAddress;
    requestData.contactPersonEmail = contactEmailAddress;
    requestData.requestDate = dateOfRequest;
    requestData.orgId = orgId;
    requestData.orderType = 1;
    requestData.geographicalScope = geographicalScope;
    requestData.ctResponsible = ctResponsible;
    requestData.region = region;
    requestData.quoteValidDate = formatISO(new Date(quoteValidUntil));
    if (rateCardSelection === "hardware_service" || subRateCardSelection === "customQuote") {
        if (selectedPriceList === "standard") {
            requestData.priceList = selectedPriceList;
            requestData.rateCardType = "standard";
            requestData.rateCardOption = "";
        }
        else {
            requestData.priceList = selectedPriceList;
            requestData.rateCardType = "special";
            requestData.rateCardOption = "customer_specific";
        }
    }
    else if (rateCardSelection === "vendor_specific") {
        requestData.rateCardType = "special";
        requestData.rateCardOption = rateCardSelection;
    }
    else if (rateCardSelection === "service_customquoteforhardware") {
        if (selectedServicePriceList === "standard") {
            requestData.servicePriceList = 'standard';
            requestData.rateCardType = "standard";
            requestData.rateCardOption = "vendor_specific";
        }
        else {
            requestData.servicePriceList = selectedServicePriceList;
            requestData.rateCardType = "special";
            requestData.rateCardOption = "vendor_specific";
        }
    }
    requestData.rateCardSelection = rateCardSelection;
    requestData.countryList = countryList;
    requestData.requestorType = requestorType;
    requestData.totalDevicesQuoted = numberOfAssets;
    requestData.countryVendors = reverseTransformCountryVendorDataRevitalize(vendorSelectionData);
    requestData.conversionRateType = rateConversionSelection;
    requestData.internalHPComments = internalHPComments;
    requestData.leadOrigin = leadOrigin;
    requestData.leadSource = leadSource;
    requestData.requestType = requestType;

    let countryCostMargins = [];
    const paymentUpliftColumns = ['logisticUplift', 'processingUplift', 'hardwareDownlift', 'hwDownlift'];
    if (paymentOnePointOMarginData) {
        paymentOnePointOMarginData.forEach(marginData => {
            const countryMarginData = {};
            countryMarginData.countryCode = marginData.id;
            countryMarginData.paymentType = "payment1.0";

            //SUPP2-9338 : Fixed null value error by passing 0
            Object.keys(marginData).forEach(margin => {
                if (paymentUpliftColumns.includes(margin) && marginData[margin] === '') {
                    marginData[margin] = '0';
                }
                countryMarginData[margin] = marginData[margin];
            });
            countryCostMargins.push(countryMarginData);
        });
    }
    if (paymentOnePointOneMarginData) {
        paymentOnePointOneMarginData.forEach(marginData => {
            const countryMarginData = {};
            countryMarginData.countryCode = marginData.id;
            countryMarginData.paymentType = "payment1.1";

            //SUPP2-9338 : Fixed null value error by passing 0
            Object.keys(marginData).forEach(margin => {
                if (paymentUpliftColumns.includes(margin) && marginData[margin] === '') {
                    marginData[margin] = '0';
                }
                countryMarginData[margin] = marginData[margin];
            });
            countryCostMargins.push(countryMarginData);
        });
    }
    requestData.countryCostMargins = countryCostMargins;

    // requestData.rateCardType = rateCardSelection;
    // requestData.rateCardOption = subRateCardSelection;
    requestData.selectVendorOption = vendorSelection;
    requestData.leadCountry = leadCountry;

    return requestData;
}

export const prepareEditedQuoteRequestData = (quoteDetails, userProfile) => {
    let requestData = {};

    const { emailAddress, language, userId, firstName, lastName } = userProfile;
    const {
        selectedServicePriceList, rateCardSelection, customerName, rateCardType, rateCardOption, selectedPriceList, conversionRateType, countryList,
        leadCountry, paymentOnePointOMarginData, paymentOnePointOneMarginData, vendorSelectionData, selectVendorOption,
        quoteId, orgId, contactPersonEmail, requestDate, quoteCreationDate, requestorType, totalDevicesQuoted,
        geographicalScope, region, ctResponsible, salesPersonEmail, currency, quoteValidUntil = new Date()
    } = quoteDetails;

    requestData.firstName = firstName;
    requestData.lastName = lastName;
    requestData.company = customerName;
    requestData.email = emailAddress;
    requestData.languageCode = language;
    requestData.userId = userId;
    requestData.action = "save";

    requestData.quoteId = quoteId;
    requestData.quoteCreationDate = quoteCreationDate;
    requestData.currencyCode = currency;
    requestData.customerType = "direct";
    requestData.salesPersonEmail = salesPersonEmail;
    requestData.contactPersonEmail = contactPersonEmail;
    requestData.requestDate = requestDate;
    requestData.orgId = orgId;
    requestData.orderType = 1;
    requestData.geographicalScope = geographicalScope;
    requestData.ctResponsible = ctResponsible;
    requestData.region = region;
    requestData.quoteValidDate = formatISO(new Date(quoteValidUntil));
    // if (rateCardType === "standard" || (rateCardOption === "vendor_specific" && rateCardType === "special")) {
    //     requestData.priceList = 'direct';
    // } else if (rateCardOption === "customer_specific") {
    //     requestData.priceList = selectedPriceList;
    // }
    if (rateCardSelection === "hardware_service") {
        if (selectedPriceList === "standard") {
            requestData.priceList = 'direct';
            requestData.rateCardType = "standard";
            requestData.rateCardOption = "";
        }
        else {
            requestData.priceList = selectedPriceList;
            requestData.rateCardType = "special";
            requestData.rateCardOption = "customer_specific";
        }
    }
    else if (rateCardSelection === "vendor_specific") {
        requestData.rateCardType = "special";
        requestData.rateCardOption = rateCardSelection;
    }
    else if (rateCardSelection === "service_customquoteforhardware") {
        if (selectedServicePriceList === "standard") {
            requestData.servicePriceList = 'standard';
            requestData.rateCardType = "standard";
            requestData.rateCardOption = "vendor_specific";
        }
        else {
            requestData.servicePriceList = selectedServicePriceList;
            requestData.rateCardType = "special";
            requestData.rateCardOption = "vendor_specific";
        }
    }
    requestData.countryList = countryList;
    requestData.leadCountry = leadCountry;
    requestData.requestorType = requestorType;
    requestData.totalDevicesQuoted = totalDevicesQuoted;
    requestData.countryVendors = reverseTransformCountryVendorDataRevitalize(vendorSelectionData);
    requestData.conversionRateType = conversionRateType;

    let countryCostMargins = [];
    const paymentUpliftColumns = ['logisticUplift', 'processingUplift', 'hardwareDownlift', 'hwDownlift'];
    if (paymentOnePointOMarginData) {
        paymentOnePointOMarginData.forEach(marginData => {
            const countryMarginData = {};
            countryMarginData.countryCode = marginData.countryCode;
            countryMarginData.paymentType = "payment1.0";
            //SUPP2-9338 : Fixed null value error by passing 0
            Object.keys(marginData).forEach(margin => {
                if (paymentUpliftColumns.includes(margin) && marginData[margin] === '') {
                    marginData[margin] = '0';
                }
                countryMarginData[margin] = marginData[margin];
            });
            countryCostMargins.push(countryMarginData);
        });
    }
    if (paymentOnePointOneMarginData) {
        paymentOnePointOneMarginData.forEach(marginData => {
            const countryMarginData = {};
            countryMarginData.countryCode = marginData.countryCode;
            countryMarginData.paymentType = "payment1.1";
            //SUPP2-9338 : Fixed null value error by passing 0            
            Object.keys(marginData).forEach(margin => {
                if (paymentUpliftColumns.includes(margin) && marginData[margin] === '') {
                    marginData[margin] = '0';
                }
                countryMarginData[margin] = marginData[margin];
            });
            countryCostMargins.push(countryMarginData);
        });
    }
    requestData.countryCostMargins = countryCostMargins;

    // requestData.rateCardType = rateCardType;
    // requestData.rateCardOption = rateCardOption;
    requestData.selectVendorOption = selectVendorOption;

    return requestData;
}

export const prepareSaveDirectCustomerQuoteRequestData = ({
    directQuoteData,
    userSelectedVendor,
    vendorNetValues,
    vendorMatrixSelections,
    action,
    selectedVendorMaxNetValue,
    hprevitalizeStatus,
    vendorSelectionData,
    vpartialPriceProvided
}) => {
    let requestData = {};

    if (!directQuoteData) return null;

    requestData.quoteId = directQuoteData.quoteId;
    requestData.userId = directQuoteData.userId;
    requestData.action = action;
    requestData.vpartialPriceProvided = vpartialPriceProvided;
    if (action === "create" || action === "partially_created") {
        requestData.quoteCreationDate = new Date().toISOString();
    }

    let selectedVendorData = null;
    
    if (userSelectedVendor) {
        selectedVendorData = vendorNetValues.filter(v => v.id === userSelectedVendor)[0];
    }

    if (!selectedVendorData) {
        selectedVendorData = vendorNetValues[0];
    }

    requestData.selectedVendor = selectedVendorData.id;
    requestData.totalNetValue = selectedVendorData.value;
    requestData.selectedVendorMaxNetValue = selectedVendorMaxNetValue;
    const countryVendors = []
    vendorMatrixSelections.filter(vendorMatrix => {
        const obj = {};
        obj.vendors = [];
        obj.countryCode = vendorMatrix.id;

        const countryVendor = vendorSelectionData.filter(vendor => vendor.country.countryCode === vendorMatrix.id)[0].vendors.filter(vendor => vendor.vendorName === vendorMatrix.value)[0];
        obj.vendors.push({
            vendorName: vendorMatrix.value,
            revitalize: countryVendor?.value?.revitalize || false
        })
        countryVendors.push(obj);
    });

    requestData.countryVendors = [...countryVendors];
    if (directQuoteData.currencyCode) {
        requestData.currencyCode = directQuoteData.currencyCode;
    }

    return requestData;
}

export const prepareDirectCustomerCheckOut = (directCheckout, userProfile, isSwitchCheckbox) => {
    const requestObj = {
        "company": userProfile.company,
        "customerType": userProfile.customerType,
        "email": userProfile.emailAddress,
        "firstName": userProfile.firstName,
        "languageCode": LANG,
        "lastName": userProfile.lastName,
        "contactNo": userProfile.contactNo || "",
        "orderType": directCheckout.orderType,
        "userId": userProfile.userId,
        "userType": userProfile.userType,
        "countryCode": directCheckout.orderDetails.selectedCountry,
        "orgId": userProfile.orgId,
        "legalEntity": directCheckout.orderDetails.selectedLegalEntity,
        "salesContractId": userProfile.salesContractId,
        "additionalComments": directCheckout.additionalComments || ""
    }
    if (directCheckout.alternativeContactSwitchCheckbox) {
        requestObj.alternateFirstName = directCheckout.contactData.firstName;
        requestObj.alternateLastName = directCheckout.contactData.lastName;
        requestObj.alternatePhone = directCheckout.contactData.phone;
        requestObj.alternateEmail = directCheckout.contactData.email.toLowerCase();
        requestObj.isAlternateNotificationEnabled = directCheckout.contactData.isNotificationEnabled ? "Y" : "N";
    }
    if (userProfile.customerType === 'direct') {
        requestObj.poNumber = userProfile.poNumber;
    }

    if (directCheckout.orderType === '1') {
        requestObj.specialLogistics = directCheckout.specialLogistics;
        requestObj.onsiteProcessing = directCheckout.onsiteProcessing;
    }

    if (userProfile.checkoutOption === 'EXCEPTIONAL' && !isSwitchCheckbox) {
        const assetList = [];
        let totalAssets = 0;
        directCheckout.assetList.map(assetData => {
            if (parseInt(assetData.value) && assetData.asset !== 'Total') {
                totalAssets = totalAssets + assetData.value;
                assetList.push({ assetType: assetData.asset, quantity: assetData.value });
            }
        });

        requestObj.assetList = assetList;
        requestObj.totalAssets = totalAssets;
    }

    if (requestObj.orderType == 1) {
        requestObj.shippingAddress = {
            "addressLine1": directCheckout.collectionInfoData.addressLine1,
            "addressLine2": directCheckout.collectionInfoData.addressLine2 || "",
            "streetName": directCheckout.collectionInfoData.streetName,
            "streetNumber": directCheckout.collectionInfoData.streetNumber,
            "streetType": directCheckout.collectionInfoData.streetType,
            "floor": directCheckout.collectionInfoData.floor || "",
            "staircase": directCheckout.collectionInfoData.staircase || "",
            "door": directCheckout.collectionInfoData.door || "",
            "city": directCheckout.collectionInfoData.city,
            "country": directCheckout.collectionInfoData.country,
            "state": directCheckout.collectionInfoData.state,
            "zipCode": directCheckout.collectionInfoData.zipCode
        };
    }
    if (userProfile.checkoutOption === "EXCEPTIONAL" && isSwitchCheckbox) {
        requestObj.hasExceptionalQuote = isSwitchCheckbox;
    }
    if (userProfile.checkoutOption === "EXCEPTIONAL" && !isSwitchCheckbox) {
        requestObj.assetData = directCheckout.assetData;
        requestObj.hasExceptionalQuote = isSwitchCheckbox;
    }
    else {
        requestObj.quoteId = directCheckout.quoteId;
    }

    return requestObj;
}

export const prepareCreateDealRequestData = (dealDetail, countrySpecificCostMargins, countryMappingList, userId, emailAddress, legalEntityList) => {
    const countryMargins = {};
    const countryMappingSelected = {};
    countryMappingList.map(countryMapping => {
        const { country, paymentType, currency, vendorName, onsiteProcessing, specialLogistics, directCustomerPricing, customerServiceRateCard, revitalizeCountry } = countryMapping;
        countryMappingSelected[country] = {
            currency,
            paymentType,
            vendorName,
            onsiteProcessing,
            specialLogistics,
            directCustomerPricing,
            customerServiceRateCard,
            revitalizeCountry
        }
        countryMargins[country] = {};
    });


    countryMappingList.map(countryMapping => {
        const { country } = countryMapping;
        const filteredCountrySpecificCostMargins = countrySpecificCostMargins.filter(countryCostMargin => countryCostMargin.countryCode === country) || [];
        filteredCountrySpecificCostMargins.map(countryCostMargin => {
            const { assetType, countryCode, logisticUplift, processingUplift, hardwareDownlift } = countryCostMargin;
            countryMargins[countryCode][assetType] = {
                countryCode,
                logisticUplift,
                processingUplift,
                hwDownlift: hardwareDownlift
            }
        });
    });

    // dealDetail.dealExpirationDate = dealDetail.dealExpirationDate ? new Date(dealDetail.dealExpirationDate).toISOString() : new Date().toISOString();
    // dealDetail.dealStartDate = dealDetail.dealStartDate ? new Date(dealDetail.dealStartDate).toISOString() : new Date().toISOString();
    const selectedLegalEntities = [];
    legalEntityList.map(entity => {
        if (entity.activeInDeal) {
            selectedLegalEntities.push({
                legalEntityId: entity.legalEntityId,
                hpPONumber: entity.hpPONumber || null
            });
        }
    });
    const requestObj = {
        ...dealDetail,
        dealExpirationDate: dealDetail.dealExpirationDate ? new Date(dealDetail.dealExpirationDate).toISOString() : new Date().toISOString(),
        dealStartDate: dealDetail.dealStartDate ? new Date(dealDetail.dealStartDate).toISOString() : new Date().toISOString(),
        email: emailAddress,
        userId: userId,
        countryList: ["US"],
        countryMappingSelected,
        countryMargins,
        selectedLegalEntities
    };
    return requestObj;
}


export const prepareCheckDuplicateDealRequestData = (dealDetail, countryMappingList, userId, emailAddress) => {
    const countryMargins = {};
    const countryMappingSelected = {};
    countryMappingList.map(countryMapping => {
        const { country, paymentType, currency, vendorName, onsiteProcessing, specialLogistics, directCustomerPricing, customerServiceRateCard, revitalizeCountry } = countryMapping;
        countryMappingSelected[country] = {
            currency,
            paymentType,
            vendorName,
            onsiteProcessing,
            specialLogistics,
            directCustomerPricing,
            customerServiceRateCard,
            revitalizeCountry
        }
        countryMargins[country] = {};
    });

    const requestObj = {
        ...dealDetail,
        dealExpirationDate: dealDetail.dealExpirationDate ? new Date(dealDetail.dealExpirationDate).toISOString() : new Date().toISOString(),
        dealStartDate: dealDetail.dealStartDate ? new Date(dealDetail.dealStartDate).toISOString() : new Date().toISOString(),
        email: emailAddress,
        userId: userId,
        countryList: ["US"],
        countryMappingSelected
    };
    return requestObj;
}
export const prepareCreateCustomerEntityRequestData = (customerEntityDetails, legalEntityList, userId, action) => {
    const requestObj = {
        "action": action,
        "createdByUserId": userId,
        "companyName": customerEntityDetails.companyName,
        "orgId": customerEntityDetails.orgId,
        "legalEntityList": legalEntityList
    }
    return requestObj;
}

export const prepareDirectCustomerOrderListRequestData = (config) => {
    let result = {};
    result.offset = config.offset;
    result.limit = config.limit || 6;
    result.searchText = config.searchText ? config.searchText : " ";
    result.sortBy = config.sortBy;
    result.orderBy = config.orderBy;
    result.customerType = "direct";
    return result;
}

export const prepareIndirectCustomerOrderListRequestData = (config) => {
    let result = {};
    result.offset = config.offset;
    result.limit = config.limit || 6;
    result.searchText = config.searchText ? config.searchText : " ";
    result.sortBy = config.sortBy;
    result.orderBy = config.orderBy;
    result.customerType = "indirect";
    return result;
}